import React, {
    createContext,
    useContext,
    useEffect,
    useState,
    useCallback,
} from "react";
import { apiMe, apiLogin, apiLogout } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    const refresh = useCallback(async () => {
        try {
            const me = await apiMe();
            setUser(me);
            return me;
        } catch {
            setUser(null);
            return null;
        }
    }, []);

    useEffect(() => {
        (async () => {
            await refresh();
            setLoading(false);
        })();
    }, [refresh]);

    const login = useCallback(async (email, password) => {
        const res = await apiLogin(email, password);
        setUser(res.user);
        return res; // caller reads must_change_password
    }, []);

    const logout = useCallback(async () => {
        try {
            await apiLogout();
        } catch {
            /* noop */
        }
        setUser(null);
    }, []);

    return (
        <AuthContext.Provider
            value={{ user, setUser, loading, refresh, login, logout }}
        >
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    const ctx = useContext(AuthContext);
    if (!ctx) throw new Error("useAuth must be used within AuthProvider");
    return ctx;
}
